import React from 'react';

const InventoryPage = () => {
  return (
    <div className="card">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h3>Inventory & Warehouse</h3>
        <button className="secondary">Sync Stock</button>
      </div>
      <div className="filters">
        <div className="filter-row">
          <div><label>SKU / Product</label><input placeholder="Search SKU" /></div>
          <div><label>Warehouse</label><select><option>Main</option><option>East</option></select></div>
          <div><label>Stock</label><select><option>All</option><option>Low</option><option>Out of stock</option></select></div>
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Product</th>
            <th>Warehouse</th>
            <th>Available</th>
            <th>Reserved</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>SKU-1002</td><td>Oxford Shirt</td><td>Main</td><td>120</td><td>12</td></tr>
          <tr><td>SKU-2021</td><td>Linen Kurta</td><td>East</td><td>35</td><td>4</td></tr>
        </tbody>
      </table>
    </div>
  );
};

export default InventoryPage;
